import { fetchApi } from '@/config/axiosSetting';
import { PatchBodyVehicleInformationAfterInquiryType } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodyVehicleInformationAfterInquiry/patchBodyVehicleInformationAfterInquiry.type';

export const patchBodyVehicleInformationAfterInquiryFunction = ({
  id,
  data,
}: PatchBodyVehicleInformationAfterInquiryType) => {
  return fetchApi.patch(`/body/reports/${id}/vehicle_information/`, {
    ...data,
  });
};
